import React, { useContext } from "react";
import PropTypes from "prop-types";

import { LocationTanksTable } from "../../../../components/Locations";

import { ModalContext } from "../../../../components/ModalProvider";

const Tanks = ({ locationRecId }) => {
  const { setModalOpen } = useContext(ModalContext);
  return <LocationTanksTable id={locationRecId} setModalOpen={setModalOpen} />;
};
Tanks.propTypes = {
  locationRecId: PropTypes.number.isRequired
};
export default Tanks;
